import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=31293832&scoped=true&"
import script from "./EventPopup.vue?vue&type=script&lang=ts&"
export * from "./EventPopup.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopup.vue?vue&type=style&index=0&id=31293832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31293832",
  null
  
)

export default component.exports